export const environment = {
  production: true,
};
export const API_PREFIX = "https://api.safarivet.com/api/";
export const IMG_PREFIX = "https://api.safarivet.com";
export const NODE_API_PREFIX = "https://api.safarivet.com/ai-api/";

/* export const API_PREFIX = "http://192.168.1.108:5000/api/";
  export const IMG_PREFIX = "http://192.168.1.108:5000"; */

export const COOKIE_PREFIX = "wsfr";
export const COOKIE_ADMIN_PREFIX = "wsap";
// export const FRONT_DOMAIN = "https://wellness.demoserver.biz";
export const ADMIN_DOMAIN = "https://wellness.safarivet.com/admin";
export const SOCKET_URL = "https://api.safarivet.com/socket.io";
export const SOCKET_SECRET_TOKEN =
  "FcayVjU4Mb3WxHrSDivlLrq0S45454545bKenCTtaT8BOu9gxZHe4n7AXmp9WlJk";